/**
 * Orders list search hint (kanban 699f7c24, usage-graph finding C6).
 *
 * Every Sage order number is "AU" + five digits, so a search for "au",
 * "au0" or "au01" narrows almost nothing: those characters are shared
 * by every numbered order. When the typed query is still such a bare
 * prefix, the page shows a hint to type the trailing digits instead.
 */

/** Placeholder for the Orders search box. */
export const ORDER_SEARCH_PLACEHOLDER =
  'Search by order # digits (e.g. 1582), customer name, customer #, PO #, or salesperson...';

/** Hint shown while the query is a bare order-number prefix. */
export const BARE_PREFIX_HINT =
  'Every order number starts with AU0. Type just the last digits, for example 1582 for AU01582.';

const BARE_PREFIX = /^au(0[0-2]?)?$/i;

/**
 * True when `query` is only the part every order number shares:
 * "au", "au0", "au00", "au01" or "au02" (any case, surrounding spaces
 * ignored). "au015" and "1582" already narrow the list and return false.
 */
export function isBareOrderNumberPrefix(query: string): boolean {
  return BARE_PREFIX.test(query.trim());
}
